import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=9ca7d48e&scoped=true&ts=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=9ca7d48e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca7d48e"]])

export default __exports__